import script from "./AlarmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlarmModal.vue?vue&type=script&setup=true&lang=ts"

import "./AlarmModal.vue?vue&type=style&index=0&id=13da0fa2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13da0fa2"]])

export default __exports__